import React from "react"
import { Link } from "react-router-dom"
import { Button, Grid } from "@mui/material"

import RoundedCard from "./product-marketing/RoundedCard"
import { CoursePromo } from "../../types"

type CoursePreviewBlockTypes = {
  course: CoursePromo
  state: string
}

function buildCourseLink(state: string, course: CoursePromo) {
  return `/${state.toLocaleLowerCase()}/course/${course.courseType}`
}

const CoursePreviewBlock = ({ course, state }: CoursePreviewBlockTypes) => (
  <Grid item xs={12} sm={6} md={4}>
    <RoundedCard className="top-accent">
      <h3 style={{ marginTop: 0 }}>{course.pageTitle}</h3>
      <p>{course.subhead}.</p>
      <ul>
        {course.features.map((feature, i) => (
          <li key={i}>{feature.head}</li>
        ))}
      </ul>
      <Button
        variant="contained"
        component={Link}
        to={buildCourseLink(state, course)}
        sx={{ marginTop: 2 }}
      >
        Learn More
      </Button>
    </RoundedCard>
  </Grid>
)

export default CoursePreviewBlock
